import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import {Row, Col, Label, Input, InputGroup,FormFeedback} from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class CreateMultiselect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre: 0,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        MultiselectIDs: PropTypes.func.isRequired,
    }
    

    setSelects(data){
        this.setState({
            padre: data.padre_id,
        });
        
    }
    render() {
        return (
            <ParadigmaModal 
            getUrl={api.usuarios.permisos.edit} 
            postUrl={api.usuarios.permisos.edit} 
            onSubmit={() => this.props.onSubmit()}  
            MultiselectIDs={this.props.MultiselectIDs}
            multiselect={true}
            successMessage={"El Permiso ha sido editado con éxito."} 
            missingIdMessage={"Debe seleccionar una fila."} 
            title={"Editar Permiso"}
            buttonIcon={"fa fa-pencil fa-lg"} 
             
            saveButton={true} 
            closeButton={true}
            onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-12">
                        <Label>Nombre</Label>
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Descripción</Label>
                        <Input type="textarea" name="descripcion" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Padre</Label>
                        <ParadigmaAsyncSeeker fieldName={"padre_id"} url={api.usuarios.permisos.select} value={this.state.padre}/>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default CreateMultiselect;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Permisos/CreateMultiselect.js